import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Banner, Button, Container, TextField } from '@tryhackme/thm-ui-components';
import styled, { keyframes } from 'styled-components';

import { ReactComponent as RocketmanImage } from 'src/images/svgs/rocketman.svg';
import { ReactComponent as WavesImage } from 'src/images/svgs/waves.svg';

export const StyledHomeContainer = styled(Container)`
  display: flex;
  flex-direction: column;
  gap: 8.4rem;

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    gap: 10rem;
  }
`;

export const StyledDescription = styled.span<{ isLeft?: boolean; fullWidth?: boolean }>`
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  line-height: ${({ theme }) => theme.fonts.lineHeight.default};
  color: ${({ theme }) => theme.colors.grey[900]};
  text-align: ${({ isLeft }) => (isLeft ? 'left' : 'center')};

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    max-width: ${({ fullWidth }) => (fullWidth ? '100%' : '56%')};
  }
`;

export const StyledBanner = styled(Banner)`
  align-items: unset;
  height: 84.7rem;

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    height: 61rem;
  }
`;

const hovering = keyframes`
  0% {
    transform: translate3d(0px, 0px, 0);
  }
  25% {
    transform: translate3d(10px, -10px, 0);
  }
  50% {
    transform: translate3d(5px, 5px, 0);
  }
  75% {
    transform: translate3d(-10px, 10px, 0);
  }
  100% {
    transform: translate3d(0px, 0px, 0);
  }
`;

export const StyledRocketmanSvg = styled(RocketmanImage)`
  animation: ${hovering} 10s infinite;
  width: 21.4rem;
  height: 25.2rem;
  position: absolute;
  bottom: 12vh;
  right: 7.5rem;

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    bottom: 10vh;
    right: 3.8rem;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    min-width: 30rem;
    height: 35.8rem;
    position: unset;
  }
`;

export const StyledContainerOuter = styled(Container)`
  z-index: 1;
`;

export const StyledContainerInner = styled(Container)`
  margin-top: 4.3rem;

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    margin-top: 8rem;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    display: flex;
    justify-content: space-between;
    margin-top: 13rem;
  }
`;

export const StyledTextContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledTextWrapper = styled.div`
  display: flex;
  gap: 1rem;
`;

export const StyledTextContent = styled.div`
  margin: 4.6rem 0 3rem 0;
  display: flex;
  flex-direction: column;
  gap: 2.4rem;
  width: max-content;

  div > div:focus,
  div > div:focus-within {
    border: 0.1rem solid ${({ theme }) => theme.colors.secondary.lighter};
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    flex-direction: row;
    gap: 1.6rem;
  }
`;

export const StyledSecondaryTextContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2.4rem;

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    flex-direction: row;
  }
`;

export const StyledTextField = styled(TextField)`
  width: 28rem;
`;

export const StyledButton = styled(Button)`
  width: max-content;

  && {
    &&:hover {
      color: ${({ theme }) => theme.colors.white};
    }
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    width: 100%;
  }
`;

export const StyledTickIcon = styled(FontAwesomeIcon)`
  width: 1.8rem;
  height: 1.4rem;
  color: ${({ theme }) => theme.colors.primary.main};
`;

export const StyledText = styled.span`
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  line-height: 1.6rem;
  color: ${({ theme }) => theme.colors.white};
`;

export const StyledWavesSvg = styled(WavesImage)`
  width: 200%;
  position: absolute;
  bottom: -2rem;

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    width: 100%;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.xl}) {
    bottom: -8rem;
    max-width: 300rem;
  }
`;
